import React, { useContext, useReducer } from "react";

import GlobalContext                           from "../../isp._comun/contexto/GlobalContext";
import * as TipoDeError                        from "../../isp._comun/servicios/Errores";
import {
    NotificacionToastDeCreacion,
    NotificacionToastDeError,
}                                              from "../../isp._comun/componentes/widgets/Notificaciones";

import FactReducer from "../reductores/FactReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";

import CargaDeClienteConsultado from "../reductores/acciones/dispatch/CargaDeClienteConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";
// import Estado from "../../reductores/EstadoDialogoClienteAFacturar";
import { TipoDeCliente } from "../reductores/Constantes";

import ServicioRegistroDeClienteAFacturar from "../../isp.servicios.clientes/ServicioRegistroDeClienteAFacturar";
import ServicioDeActualizacionDeClienteAFacturar from "../../isp.servicios.clientes/ServicioDeActualizacionDeClienteAFacturar";
import ServicioDeQueryDeUnClienteAFacturar from "../../isp.servicios.clientes/ServicioDeQueryDeUnClienteAFacturar";


// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
import DataDeRespuestas_Facturacion from "../../isp.servicios.clientes/DataEstaticaDeRespuestas.json";
// import { ModosOp } from "../../../_comun/Constantes";
// import EsperarClienteConsultado from "../../reductores/acciones/dispatch/EsperarClienteConsultado";
// import { dispatchGeneral } from "../../../_comun/presentadores/dispatchGeneral";
// import useHandlerDeServicio from '../../../_comun/presentadores/useHandlerDeServicioQueUsaSesionId'
import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import DialogoClienteAFacturar                 from "./layouts/DialogClienteAFacturar";

const DialogoInteractivoDeCliente = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        notificar,
    } = useContext(GlobalContext);

    //actualiza estadoInicial de la entrada si hay algun input
    /* let funcionEstadoInicial = null;
    if(ventana.estadoCom.flag.modoOperacion === ModosOp.CREAR){
        funcionEstadoInicial = Estado.getEstadoInicial;
    }
    if(ventana.estadoCom.flag.cargandoEntidad){
        const estadoInicial = Estado.getEstadoInicial();
        funcionEstadoInicial = () =>{
            estadoInicial.flag.modal=
        }
    }
    const [estadoDCF, dispatchDCF] = useReducer(FactReducer, null, funcionEstadoInicial); */
    // const [estadoDCF, dispatchDCF] = useReducer(FactReducer, estadoInicial);
    // const [estadoDCF, dispatchDCF] = useReducer(FactReducer, Estado.getEstadoInicial());
    // const estadoDCF = ventana.estadoDCF;
    
    /* if (
        estadoDCF.flag.iniciando &&
        ventana.estadoCom.flag.modoOperacion !== ModosOp.CREAR
        ) {
            const estadoInicial = ventana.estadoCom
            ventana.estadoCom = estadoDCF;
            ventana.dispatch = dispatchDCF;
            dispatchDCF(new EsperarClienteConsultado(estadoInicial));
            return;
        } */
        
    const [estadoDCF, dispatchDCF] = useReducer(FactReducer, ventana.estadoComp);
    ventana.estadoComp = estadoDCF;
    ventana.dispatch = dispatchDCF;

    const registrarClienteAFacturar = useHandlerDeComandoConSesionActiva( async () => {
        let bloqueIdentificacion;
        if (estadoDCF.domain.screen.tipoCliente === TipoDeCliente.DocId) {
            bloqueIdentificacion = {
                tipoDoc: estadoDCF.domain.screen.tipoDoc,
                nroDoc: estadoDCF.domain.screen.nroDoc,
                nombres: estadoDCF.domain.screen.nombres,
                apellidos: estadoDCF.domain.screen.apellidos,
                sexo: estadoDCF.domain.screen.sexo,
            };
        } else {
            bloqueIdentificacion = {
                razonSocial: estadoDCF.domain.screen.razonSocial,
                ruc: estadoDCF.domain.screen.ruc,
            };
        }
        const clienteAFact = {
            tipoCliente: estadoDCF.domain.screen.tipoCliente,
            ...bloqueIdentificacion,

            general: {
                telcel1: estadoDCF.domain.screen.general.telcel1,
                telcel2: estadoDCF.domain.screen.general.telcel2,
                telfijo: estadoDCF.domain.screen.general.telfijo,
                email: estadoDCF.domain.screen.general.email,
                sitioWeb: estadoDCF.domain.screen.general.sitioWeb,
            },
            /*
            cobranza: {
                modoCobro: estadoDCF.modoCobro,
                tipoComprobante: estadoDCF.tipoComprobante,
                cicloFact: estadoDCF.cicloFact,
            },
            
            personasContacto: estadoDCF.personasContacto.contactosAct, */
        };
        // Object.setPrototypeOf(clienteAFact, ClienteAFacturar.prototype);

        try {
            const dataRegistradaDeClienteAFacturar = await new ServicioRegistroDeClienteAFacturar().ejecutar(
                clienteAFact
            );
            dispatchDCF(new Action.CargaDeClienteRegistrado(dataRegistradaDeClienteAFacturar));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.titulo,
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.mensaje,
                    dataRegistradaDeClienteAFacturar.idCliente
                )
            );
        } catch (error) {
            
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearCliente(error.data));
                return;
            }
            
            /* if (error instanceof TipoDeError.ErrorEnIdSesion) {
                cargarPantallaLogin();
                return;
            } */
            if (error instanceof TipoDeError.ErrorTecnico){
                dispatchDCF(new Action.FinalizarComando());

                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            throw error;
        }
    });

    const actualizarClienteAFacturar = useHandlerDeComandoConSesionActiva( async () => {
        const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        };

        try {
            // const dataDeClienteActualizado =
            await new ServicioDeActualizacionDeClienteAFacturar().ejecutar(clienteAFactPorActualizar);
            dispatchDCF(
                new Action.CargaDeClienteActualizado()
                // new Action.CargaDeClienteActualizado(dataDeClienteActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico){
                dispatchDCF(new Action.FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                    /* new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError +
                            CodigoDeError[nombreDeError] +
                            "\n" +
                            DataDeRespuestas_Comun[nombreDeError].descripcion
                    ) */
                /*); */
                
            }
            throw error;
            
        }
    });

    const buscarUnSoloClienteAFacturar = useHandlerDeComandoConSesionActiva( async (idCliente) => {
        try {
            // const respuestaQuery = await new ServicioDeQueryDeUnClienteAFacturar().ejecutar("undefinido");
            const respuestaQuery = await new ServicioDeQueryDeUnClienteAFacturar().ejecutar(idCliente);
            dispatchDCF(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
                
            }
            throw error;
        }
    });

    return (
        <DialogoClienteAFacturar
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            // registrarClienteAFacturar={useHandlerDeServicio(registrarClienteAFacturar)}
            registrarClienteAFacturar={registrarClienteAFacturar}
            // actualizarClienteAFacturar={useHandlerDeServicio(actualizarClienteAFacturar)}
            actualizarClienteAFacturar={actualizarClienteAFacturar}
            buscarUnSoloClienteAFacturar={buscarUnSoloClienteAFacturar}
        />
    );
}

export default DialogoInteractivoDeCliente;
